import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Link, Typography } from '@material-ui/core';
import Footer from '../components/Footer';
import { ReactComponent as LumioLogo } from '../assets/img/lumio-drop.svg';
import { ReactComponent as LumioLogoMobile } from '../assets/img/lumio-drop-mobile.svg';
import { ReactComponent as HomeDraw } from '../assets/img/home-draw.svg';

const useStyles = makeStyles((theme) => ({
    homeWrapper: {
        height: "auto",
        display: "flex",
        alignItems: "center",
        flexDirection: "column"
    },
    homeContainer: {
        paddingTop: 16,
        paddingBottom: 16,
        height: "auto",
        minHeight: "calc(100vh - 60px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        position: "relative",
        [theme.breakpoints.up('md')]: {
            paddingTop: 40,
            paddingBottom: 40,
        },
    },
    homeDraw: {
        width: 500,
        height: 400,
        bottom: -260,
        right: 0,
        position: "absolute",
        zIndex: 1000,
        display: "block",
        [theme.breakpoints.down('sm')]: {
            width: 400,
            height: 300,
        },
        [theme.breakpoints.down('xs')]: {
            display: "none"
        },
    },
    lumioLogo: {
        display: "none",
        marginTop: 32,
        marginBottom: 32,
        marginLeft: -56,
        [theme.breakpoints.up('lg')]: {
            display: "block"
        },
    },
    lumioLogoMobile: {
        display: "block",
        marginTop: 32,
        marginBottom: 20,
        marginLeft: -56,
        [theme.breakpoints.up('lg')]: {
            display: "none"
        },
    },
    descriptionWrapper: {
        position: "relative",
        zIndex: 9000,
    },
    homeTitle: {
        margin: "32px 0",
        fontWeight: 600
    },
    homeSubtitle: {
        marginBottom: 16,
        lineHeight: "1.625em"
    },
    dropButtonText: {
        textDecoration: "none"
    },
    dropButton: {
        margin: "16px 0"
    },
    faq: {
        marginTop: 64,
        marginBottom: 32,
        display: "flex",
        flexDirection: "column"
    },
    faqItem: {
        marginBottom: 6
    }
}));

const Home = () => {
    const classes = useStyles();

    return (
        <>
            <div className={classes.homeWrapper}>
            <Container maxWidth="md" className={classes.homeContainer}>
                
                
                <LumioLogo className={classes.lumioLogo}/>
                <LumioLogoMobile className={classes.lumioLogoMobile}/>

                <div className={classes.descriptionWrapper}>
                    <Typography variant="subtitle1"  className={classes.homeSubtitle}>
                        This is where you can drop your campaign files
                        <br/>
                        to be directly used inside Lumio by your Content Manager.
                    </Typography>
                    <Typography variant="subtitle1"  className={classes.homeSubtitle}>
                        You can directly drag and drop the files and upload it to our cloud. 
                        <br/>
                        We only accept image and video format.
                    </Typography>
                    <Typography variant="subtitle1"  className={classes.homeSubtitle}>
                        You'll receive a unique Drop ID that later can 
                        <br/>
                        be informed to your Content Manager.
                    </Typography>

                    <HomeDraw className={classes.homeDraw}/>
                </div>
                    
                <div>
                    <Button 
                        variant="contained" 
                        color="primary" 
                        size="large" className={classes.dropButton}
                        component={RouterLink} 
                        to="/drop"
                    >
                        Get Started
                    </Button>
                </div>

                <div className={classes.faq}>
                    <div className={classes.faqItem}>
                        <Link href="https://www.lumio.id" target="_blank" rel="noopener" variant="body2">What is Lumio?</Link>
                    </div>
                    <div className={classes.faqItem}>
                        <Link href="https://help.lumio.id/drop" target="_blank" rel="noopener" variant="body2">How does Lumio Drop works?</Link>
                    </div>
                    <div className={classes.faqItem}>
                        <Link href="https://help.lumio.id/drop/drop-id" target="_blank" rel="noopener" variant="body2">What is Drop ID?</Link>
                    </div>
                </div>
                
            </Container>

            <Footer />
        </div>
        </>
    );
};

export default Home;